require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-ada-apartment-currently-featured-on-urban.json") })
        }
      }, "path---journal-ada-apartment-currently-featured-on-urban");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-ada-apartment-currently-featured-on-urban!./.cache/json/journal-ada-apartment-currently-featured-on-urban.json
// module id = 449
// module chunks = 231608221292675